<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="30rem"
  >
    <template v-slot:activator="{ on }">
      <v-btn small icon text v-on="on">
        <v-icon small>fa-edit</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="end" no-gutters>
          <v-btn small icon text @click="dialog = false">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row align="center">
          <v-col v-if="template.sales_target !== null" cols="12" sm="6">
            <j-decimal-input
              filled
              hide-details
              unit-suffix
              class="no-before my-1"
              label="Quantité minimum"
              v-model="newValue.quantity_min"
              :suffix="getProductUnit()"
            ></j-decimal-input>
          </v-col>
          <v-col cols="12" :sm="template.sales_target !== null ? 6 : 12">
            <j-decimal-input
              filled
              hide-details
              unit-suffix
              class="no-before my-1"
              :label="
                template.sales_target !== null
                  ? 'Quantité selon les ventes'
                  : 'Quantié à produire'
              "
              v-model="newValue.quantity"
              :suffix="getProductUnit()"
            ></j-decimal-input>
          </v-col>
        </v-row>
        <v-row no-gutters v-if="loading">
          <v-progress-linear indeterminate></v-progress-linear>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row align="center" justify="end" no-gutters>
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            color="success"
            :disabled="loading"
            @click="saveTemplateProduct"
          >
            <v-icon small left>fa-save</v-icon>Enregistrer
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ProductPreparationSlipAdderDialog",
  props: {
    product: {
      required: true
    },
    templateProduct: {
      required: true
    },
    template: {
      required: true
    }
  },
  computed: {
    ...mapGetters(["getRecipes", "getStoreId"])
  },
  data() {
    return {
      loading: false,
      dialog: false,
      newValue: {
        quantity_min: null,
        quantity: 0
      }
    };
  },
  methods: {
    async saveTemplateProduct() {
      try {
        this.loading = true;
        if (this.templateProduct !== undefined) {
          const data = {
            ...this.templateProduct,
            quantity_min:
              this.newValue.quantity_min > 0
                ? this.newValue.quantity_min
                : null,
            quantity: this.newValue.quantity
          };
          this.$emit("update", { method: "patch", data: data });
          //await api.patchPreparationSlipTemplateProduct(data.id, data);
        } else {
          const data = {
            fk_preparation_slip_template: this.template.id,
            fk_product: this.product,
            quantity_min:
              this.newValue.quantity_min > 0
                ? this.newValue.quantity_min
                : null,
            quantity: this.newValue.quantity,
            force_show: false,
            store: this.getStoreId
          };
          this.$emit("update", { method: "post", data: data });
          //await api.postPreparationSlipTemplateProduct(data);
        }
        this.dialog = false;
      } finally {
        this.loading = false;
      }
    },
    getProductUnit() {
      const recipe = this.getRecipes.find(
        x => x.fk_produit_intermediaire === this.product
      );
      if (recipe) {
        if (recipe.data && recipe.data.use_conversion_formula) {
          return recipe.data.unite_inventory;
        } else {
          return recipe.unite_produite;
        }
      }
      return "";
    }
  },
  watch: {
    dialog(v) {
      if (v === true) {
        if (this.templateProduct !== undefined) {
          this.newValue.quantity_min =
            this.templateProduct.quantity_min !== null
              ? Number(this.templateProduct.quantity_min)
              : this.templateProduct.quantity_min;
          this.newValue.quantity = Number(this.templateProduct.quantity);
        } else {
          this.newValue.quantity_min = null;
          this.newValue.quantity = 0;
        }
      }
    }
  }
};
</script>

<style></style>
